import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { withTranslatedMeta } from 'i18n/utils'

import { openReservationDetails, closeReservationDetails } from '../../actions'
import { selectedReservationSelector } from '../../selectors'

import scrollTop from 'shared/scroll-top'

import Reservations from './Reservations'
import ReservationDetails from './ReservationDetails'

import styles from '../styles.module.scss'

//TODO Scrolls most likely can't work this way. These should be revisited and removed if there is not effect
const ReservationsView = () => {
    const [previousScrollY, setPreviousScrollY] = useState(0)
    const selectedReservationId = useSelector(selectedReservationSelector)
    const dispatch = useDispatch()

    useEffect(
        () => () => {
            dispatch(closeReservationDetails())
        },
        []
    )

    const onSelectReservation = (reservationId, reservation) => {
        setPreviousScrollY(prevState => {
            scrollTop()
            window.scrollTo(0, 0)
            dispatch(openReservationDetails(reservationId))
            return window.scrollY
        })
    }

    const onCloseReservationDetails = () => {
        dispatch(closeReservationDetails())
        scrollTop(previousScrollY)
    }

    return (
        <div className={classNames('container', styles.reservationsContainer)}>
            {selectedReservationId ? (
                <ReservationDetails reservationId={selectedReservationId} onClose={onCloseReservationDetails} />
            ) : (
                <Reservations onSelectReservation={onSelectReservation} />
            )}
        </div>
    )
}
export default compose(withTranslatedMeta('dashboard.menu.transactions'))(ReservationsView)
